// Third-party libs
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');

// Common
require('../../../assets/scripts/common/jv.Filters.webpack.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/common/jv.BrowserDetails.js');
require('../../../assets/scripts/common/angajaxservice.js');
require('../../../assets/scripts/common/polyfills.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/common/directives/jv.Select2.js');

// Videos (Jobseeker)
require('../../../assets/scripts/videos/jobseeker/jv.Videos.RequestExtensionModal.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Svc.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.List.Ctrl.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.App.List.js');
